import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const NavbarContainer = styled.nav`
  background-color: var(--color-surface);
  padding: 0 20px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const LogoContainer = styled(NavLink)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  background-image: url("/images/LogoImpact.svg");
  background-size: 50px 50px;
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 60px;
  min-height: 50px;
  justify-content: center;
`;

const LogoTitle = styled.span`
  font-size: 26px;
  font-weight: normal;
  font-family: 'Impact', 'Haettenschweiler', 'Arial Narrow Bold', sans-serif;
  color: var(--color-text);
  line-height: 1.1;
`;

const LogoSubtitle = styled.span`
  font-size: 10px;
  font-weight: normal;
  font-family: 'Impact', 'Haettenschweiler', 'Arial Narrow Bold', sans-serif;
  color: var(--color-text);
  text-align: right;
  letter-spacing: 3px;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 992px) {
    display: none;
  }
`;

const StyledNavLink = styled(NavLink)`
  color: var(--color-text);
  text-decoration: none;
  padding: 0 15px;
  font-size: 18px;
  height: 70px;
  line-height: 70px;
  transition: color 0.3s;

  &.active {
    color: var(--color-accent);
  }

  &:hover {
    color: var(--color-accent);
  }
`;

const MobileMenuIcon = styled.div`
  display: none;
  font-size: 30px;
  cursor: pointer;

  @media (max-width: 992px) {
    display: block;
  }
`;

const MobileMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-surface);
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  padding: 20px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 999;
  transform: ${(props) =>
    props.$isOpen ? "translateY(0)" : "translateY(-120%)"};
  transition: transform 0.3s ease-in-out;
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        // CHANGEMENT ICI
        setIsOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <NavbarContainer>
        <LogoContainer to="/">
          <LogoTitle>IMPACTISOL</LogoTitle>
          <LogoSubtitle>CALORIFUGE</LogoSubtitle>
        </LogoContainer>
        <NavLinks>
          <StyledNavLink to="/" end>
            Accueil
          </StyledNavLink>
          <StyledNavLink to="/societe">Société</StyledNavLink>
          <StyledNavLink to="/realisations">Réalisations</StyledNavLink>
          <StyledNavLink to="/contact">Contact</StyledNavLink>
        </NavLinks>
        <MobileMenuIcon onClick={() => setIsOpen(!isOpen)}>☰</MobileMenuIcon>
      </NavbarContainer>
      <MobileMenu $isOpen={isOpen} onClick={() => setIsOpen(false)}>
        <StyledNavLink to="/" end>
          Accueil
        </StyledNavLink>
        <StyledNavLink to="/societe">Société</StyledNavLink>
        <StyledNavLink to="/realisations">Réalisations</StyledNavLink>
        <StyledNavLink to="/contact">Contact</StyledNavLink>
      </MobileMenu>
    </>
  );
};

export default Navbar;
